import React from "react";

// Pairvio mark: two overlapping speech bubbles that form a connection.
export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M29 13C18 11 8 19 8 31c0 9 6 16 14 18l-3 7 11-7c-6-4-9-10-9-17 0-8 3-14 8-19Z"
        fill="#0F172A"
      />
      <path d="M35 13c11-2 21 6 21 18 0 9-6 16-14 18l3 7-11-7c6-4 9-10 9-17 0-8-3-14-8-19Z" fill="#1E293B" />
      <circle cx="32" cy="32" r="3.2" fill="#FF5F65" />
    </svg>
  );
}

export function Logo({ size = 30, className = "", textClassName = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <LogoMark size={size} />
      <span
        className={`font-semibold uppercase ${textClassName}`}
        style={{ fontFamily: '"Inter", sans-serif', fontSize: size * 0.52, letterSpacing: "0.2em" }}
      >
        PAIRVIO
      </span>
    </span>
  );
}
